<script>
	import { onMount } from "svelte";
	export let prices;
	let btc = 0.03;
	let xrp = 2580;
	let eth = 0.25;
	let initial_invest_eur = 1300;
	let usd_eur;

	onMount(async () => {
		fetch('https://api.binance.com/api/v3/avgPrice?symbol=EURUSDT')
		.then(r => r.json())
		.then(data => {
			let p = parseFloat(data.price);
			usd_eur = p;
		});
	})

	$: total_usd = btc*prices.btc + xrp*prices.xrp + eth*prices.eth;

	$: total_eur = total_usd / usd_eur;

	$: evolution = Math.floor(total_eur*100 / initial_invest_eur - 100);

	$: document.title = "Cryptowav " + Math.floor(total_eur).toLocaleString('fr')
</script>



<main>

	<div class="total">
		{Math.floor(total_eur).toLocaleString('fr')} €
	</div>

	<div 
		class="evo_percentage"
		class:evo_pos="{evolution > 0}"
		class:evo_neg="{evolution < 0}"
	>
		{#if evolution > 0}
			<span>+</span>
		{:else}
			<span>-</span>
		{/if}
		{Math.abs(evolution)} %
	</div>

	<div
		class="evo_eur"
		class:evo_pos="{evolution > 0}"
		class:evo_neg="{evolution < 0}"
	>
		{#if evolution > 0}
			<span>+</span>
		{:else}
			<span>-</span>
		{/if}
		{Math.floor(total_eur - initial_invest_eur)} €
	</div>

</main>



<style>
	main {
		margin: 3rem auto;
	}

	div {
		font-size: 3rem;
		font-weight: 200;
	}

	.total {
		color: #eee;
	}

	.evo_pos {
		color: #0a0;
	}

	.evo_neg {
		color : #c00;
	}

	.evo_percentage {
		font-size: 2.5rem;
	}

	.evo_eur {
		font-size: 1.75rem;
		font-weight: 200;
	}

</style>
